(function () {
  var _currentPaymentMethod = 'bank-transfer';

  function applyPaymentMethod(method) {
    _currentPaymentMethod = method;
    document.querySelectorAll('[data-bank-transfer-price][data-normal-price]').forEach(function (el) {
      var price = method === 'bank-transfer' ? el.dataset.bankTransferPrice : el.dataset.normalPrice;
      if (!price) return;
      el.textContent = price;
      if (el.hasAttribute('value')) el.setAttribute('value', price);
    });
  }

  // Payment method toggle — event delegation so it works after morph/re-render
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.payment-method-toggle__option');
    if (!opt) return;

    var toggle = opt.closest('.payment-method-toggle');
    if (!toggle) return;

    toggle.querySelectorAll('.payment-method-toggle__option').forEach(function (o) {
      o.classList.remove('payment-method-toggle__option--active');
    });
    opt.classList.add('payment-method-toggle__option--active');

    applyPaymentMethod(opt.dataset.method);

    // Update checkout button URL
    var cartSection = toggle.closest('.cart__summary-totals');
    var parentEl = cartSection ? cartSection.parentElement : null;
    var checkoutBtn = parentEl
      ? parentEl.querySelector('.cart-checkout-unified-btn')
      : document.querySelector('.cart-checkout-unified-btn');
    if (checkoutBtn) {
      checkoutBtn.setAttribute('href', opt.dataset.checkoutUrl);
    }
  });

  // Re-apply prices after cart items re-render (e.g. quantity change, morph)
  document.addEventListener('cart:update', function () {
    if (_currentPaymentMethod !== 'bank-transfer') {
      setTimeout(function () {
        applyPaymentMethod(_currentPaymentMethod);
      }, 100);
    }
  });

  // Unified checkout button: clear stale discount then redirect
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-checkout-unified-btn');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    var url = btn.getAttribute('href') || '/checkout';

    fetch('/cart/update.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: '' }),
    })
      .catch(function () {})
      .finally(function () {
        window.location.href = url;
      });
  });
})();
